import React, { useState } from 'react';
import { MainLayout } from './components/layout/MainLayout';
import { Homepage } from './pages/Homepage';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Matters } from './pages/Matters';
import { MatterWorkspace } from './pages/MatterWorkspace';
import { Search } from './pages/Search';
import { Workflows } from './pages/Workflows';
import { MedicalChronology } from './pages/MedicalChronology';
import { DraftingCopilot } from './pages/DraftingCopilot';
import { ReviewQueue } from './pages/ReviewQueue';
import { Admin } from './pages/Admin';
import { ToastProvider } from './components/feedback/ToastProvider';
export type PersonaId = 'EF' | 'AT' | 'MS' | 'RK';
type Page = 'home' | 'login' | 'dashboard' | 'matters' | 'workspace' | 'search' | 'workflows' | 'chronology' | 'copilot' | 'review' | 'admin';
export function App() {
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const [persona, setPersona] = useState<PersonaId | null>(null);
  const [searchInitialQuery, setSearchInitialQuery] = useState<string>('');
  const handleNavigate = (page: string, query?: string) => {
    setCurrentPage(page as Page);
    if (query !== undefined) {
      setSearchInitialQuery(query);
    } else if (page !== 'search') {
      // Clear search query when navigating away from search
      setSearchInitialQuery('');
    }
  };
  const handleLogin = (personaId: string) => {
    setPersona(personaId as PersonaId);
    // Route to default page based on persona
    switch (personaId) {
      case 'EF':
        setCurrentPage('dashboard');
        break;
      case 'AT':
        setCurrentPage('chronology');
        break;
      case 'MS':
        setCurrentPage('matters');
        break;
      case 'RK':
        setCurrentPage('workflows');
        break;
      default:
        setCurrentPage('dashboard');
    }
  };
  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return <Dashboard onNavigate={handleNavigate} persona={persona} data-id="element-0" />;
      case 'matters':
        return <Matters onNavigate={handleNavigate} data-id="element-1" />;
      case 'workspace':
        return <MatterWorkspace onNavigate={handleNavigate} data-id="element-2" />;
      case 'search':
        return <Search initialQuery={searchInitialQuery} data-id="element-3" />;
      case 'workflows':
        return <Workflows onNavigate={handleNavigate} data-id="element-4" />;
      case 'chronology':
        return <MedicalChronology data-id="element-5" />;
      case 'copilot':
        return <DraftingCopilot data-id="element-6" />;
      case 'review':
        return <ReviewQueue data-id="element-7" />;
      case 'admin':
        return <Admin data-id="element-8" />;
      default:
        return <Dashboard onNavigate={handleNavigate} data-id="element-9" />;
    }
  };
  // Standalone pages that don't use the MainLayout sidebar/header
  if (currentPage === 'home') {
    return <Homepage onNavigate={handleNavigate} data-id="element-10" />;
  }
  if (currentPage === 'login') {
    return <Login onLogin={handleLogin} data-id="element-11" />;
  }
  // App pages wrapped in the layout shell
  return <ToastProvider data-id="element-12">
      <MainLayout currentPage={currentPage} onNavigate={handleNavigate} persona={persona} data-id="element-13">
        {renderPage()}
      </MainLayout>
    </ToastProvider>;
}